import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:complaints.index" },
      { key: "complaintTitle", name: "global:complaints.title" },
      { key: "[c].name", name: "global:complaints.contact.contact" },

      {
        key: "[d].serialNumber",
        name: "global:complaints.serialNumber",
      },
      {
        key: "[cb].firstName+lastName",
        name: "global:complaints.createdBy",
      },
      { key: "[s].name", name: "global:complaints.status" },
    ],
    selectedSearchFields: [
      "index",
      "complaintTitle",
      "[c].name",

      "[d].serialNumber",
      "[cb].firstName+lastName",
      "[s].name",
    ],
    dictionaryFields: ["customerExpectations", "guarantor"],
    url: "complaint",
  },
};

const complaintReducer = createSlice({
  name: "complaintReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = complaintReducer.actions;

export default complaintReducer.reducer;
